import {
  DvGridComponent,
  DvQuickFilterComponent,
  DvGridToolbarComponent,
  DvActionComponent,
} from '@devinco/ui/grid';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { pendingChangesGuard } from '@core/guards/pending-changes.guard';
import {
  DvDynamicFormModule,
  DvEditorsModule,
  DvFilterAreaModule,
  DvNavTabsModule,
  DvPanelModule,
  DvProgressSpinnerModule,
  DvSavePanelModule,
} from '@devinco/ui/legacy';
import { TranslateModule } from '@ngx-translate/core';
import { ExpensesGridComponent } from './components/trip-expenses-tab/expenses-grid/expenses-grid.component';
import { TripExpensesTabComponent } from './components/trip-expenses-tab/trip-expenses-tab.component';
import { DirectivesModule } from '@shared/directives/directives.module';
import { MapModule } from '@features/map/map.module';
import { AgGridModule } from 'ag-grid-angular';
import { MergeTripTabComponent } from './components/merge-trip-tab/merge-trip-tab.component';
import { MergeableTripsTableComponent } from './components/merge-trip-tab/mergeable-trips-table/mergeable-trips-table.component';
import { MergingDetailsComponent } from './components/merge-trip-tab/merging-details/merging-details.component';
import { TripFilterCrudDialogComponent } from './components/trip-filter-crud-dialog/trip-filter-crud-dialog.component';
import { TripInformationTabComponent } from './components/trip-information-tab/trip-information-tab.component';
import { TripOnMapTabComponent } from './components/trip-on-map-tab/trip-on-map-tab.component';
import { TripTabsComponent } from './components/trip-tabs/trip-tabs.component';
import { TripsGridComponent } from './components/trips-grid/trips-grid.component';
import { TripsPageComponent } from './trips-page.component';
import { PipesModule } from '@shared/pipes/pipes.module';
import { DvButtonComponent, DvCheckboxComponent } from '@devinco/ui/dds';
import { FormEditPermissionsDirective } from '@shared/directives/form-edit-permissions.directive';

import { DvVerticalSplitterComponent } from '@devinco/ui/dds/splitter';

export const TripRouteName = {
  Main: 'trips',
  Information: 'information',
  Expenses: 'expenses',
  OnMap: 'on-map',
  MergeTrip: 'merge-trip',
};
const routes: Routes = [
  {
    path: '',
    component: TripsPageComponent,
    children: [
      {
        path: ':id',
        pathMatch: 'full',
        redirectTo: `:id/${TripRouteName.Information}`,
      },
      {
        path: ':id',
        component: TripTabsComponent,
        children: [
          {
            path: TripRouteName.Information,
            component: TripInformationTabComponent,
            canDeactivate: [
              (component: TripInformationTabComponent) =>
                pendingChangesGuard(component),
            ],
          },
          {
            path: TripRouteName.Expenses,
            component: TripExpensesTabComponent,
          },
          {
            path: TripRouteName.OnMap,
            component: TripOnMapTabComponent,
          },
          {
            path: TripRouteName.MergeTrip,
            component: MergeTripTabComponent,
            canDeactivate: [
              (component: MergeTripTabComponent) =>
                pendingChangesGuard(component),
            ],
          },
        ],
      },
    ],
  },
];
@NgModule({
  declarations: [
    TripsPageComponent,
    TripsGridComponent,
    TripInformationTabComponent,
    TripExpensesTabComponent,
    ExpensesGridComponent,
    TripOnMapTabComponent,
    MergeTripTabComponent,
    MergeableTripsTableComponent,
    MergingDetailsComponent,
  ],
  imports: [
    FormEditPermissionsDirective,
    TripTabsComponent,
    AgGridModule,
    DvCheckboxComponent,
    CommonModule,
    RouterModule.forChild(routes),
    DvNavTabsModule,
    DirectivesModule,
    DvSavePanelModule,
    DvDynamicFormModule,
    PipesModule,
    TranslateModule,
    MapModule,
    DvButtonComponent,
    DvEditorsModule,
    DvGridComponent,
    DvQuickFilterComponent,
    DvGridToolbarComponent,
    DvActionComponent,
    DvFilterAreaModule,
    DvPanelModule,
    DvProgressSpinnerModule,
    DvVerticalSplitterComponent,
    TripFilterCrudDialogComponent,
  ],
})
export class TripsPageModule {}
